import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsPrice } from 'components/common/ns-price/NsPrice';
import { useOrderSummary } from 'components/direct-sales/order-summary/hooks/useOrderSummary';
import { formatTariffDate } from 'components/direct-sales/quote/utils';

export const SummaryContentList = () => {
  const {
    firstPaymentDate,
    productName,
    fuelTypeLabel,
    formatedPaymentDay,
    monthlyAmount,
    paymentName,
    electricityQuote,
    gasQuote,
    annualAmount,
    exitFee,
    tariffEndsOn
  } = useOrderSummary();

  return (
    <NsDescriptionList>
      {[
        {
          term: 'Your tariff',
          description: (
            <p>
              {productName}
              <br />
              Estimated cost <br />
              <NsPrice amount={monthlyAmount} /> /month (inc. VAT)
            </p>
          )
        },
        {
          term: 'Type of energy',
          description: <p>{fuelTypeLabel}</p>
        },
        ...(formatedPaymentDay
          ? [
              {
                term: 'Payment details',
                description: `${formatedPaymentDay} of every month`
              }
            ]
          : []),
        {
          term: 'Payment method',
          description: (
            <>
              <p>{paymentName}</p>
              {firstPaymentDate && (
                <p>
                  <b>Your first payment will be {firstPaymentDate}</b>
                </p>
              )}
            </>
          )
        },
        {
          term: 'Estimated annual usage',
          description: (
            <>
              {electricityQuote && (
                <>
                  <p>Electricity</p>
                  <p>
                    {electricityQuote.providedAnnualConsumption
                      ? electricityQuote.providedAnnualConsumption
                      : electricityQuote.providedAnnualConsumptionDay +
                        electricityQuote.providedAnnualConsumptionNight}{' '}
                    kWh
                  </p>
                  <p>
                    <NsPrice amount={electricityQuote.annualAmount} /> (inc.
                    VAT)
                  </p>
                  <br />
                </>
              )}
              {gasQuote && (
                <>
                  <p>Gas</p>
                  <p>
                    {gasQuote.providedAnnualConsumption} kWh <br />
                    <NsPrice amount={gasQuote.annualAmount} /> (inc. VAT)
                    <br />
                  </p>
                  <br />
                </>
              )}
              <p>Total</p>
              <p>
                <NsPrice amount={annualAmount} /> (inc. VAT)
              </p>
            </>
          )
        },
        electricityQuote && {
          term: 'Electricity',
          description: (
            <>
              <p>Standing charge </p>
              <p>{electricityQuote.standingCharge}p per day (inc. VAT)</p>
              {electricityQuote.unitRate ? (
                <>
                  <p>Unit rate </p>
                  <p>{electricityQuote.unitRate}p per kWh (inc. VAT)</p>
                </>
              ) : (
                <>
                  <p>{electricityQuote.unitRateDayName}</p>
                  <p>{electricityQuote.unitRateDay}p per kWh (inc. VAT)</p>
                  <p>{electricityQuote.unitRateNightName}</p>
                  <p>{electricityQuote.unitRateNight}p per kWh (inc. VAT)</p>
                </>
              )}
              <p>Exit fee</p>
              <p>{exitFee}</p>
            </>
          )
        },
        gasQuote && {
          term: 'Gas',
          description: (
            <>
              <p>Standing charge </p>
              <p>{gasQuote.standingCharge}p per day (inc. VAT)</p>

              <p>Unit rate </p>
              <p>{gasQuote.unitRate}p per kWh (inc. VAT)</p>
              <p>Exit fee</p>
              <p>{exitFee}</p>
            </>
          )
        },
        {
          term: 'Tariff ends on',
          description: tariffEndsOn
            ? formatTariffDate(tariffEndsOn)
            : 'Not Applicable'
        }
      ]}
    </NsDescriptionList>
  );
};
